import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const dealStatusDropdown = createAsyncThunk(
  "deals/dealStatusDropdown",
  async () => {
    const response = await axios.get(`/api/business/dealStatusDropdown`);
    return response.response;
  },
);

export const dealsView = createAsyncThunk("deals/dealsView", async (params) => {
  const status = typeof params === "object" ? params?.status : params;
  const dealCategoryId = typeof params === "object" ? params?.dealCategoryId : undefined;
  let url = `/api/business/dealsView?status=${status}`;
  if (dealCategoryId) {
    url += `&dealCategoryId=${dealCategoryId}`;
  }
  const response = await axios.get(url);
  return response.response;
});

export const raiseRequest = createAsyncThunk(
  "deals/raiseRequest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/raiseRequest", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const dealDetailedView = createAsyncThunk(
  "deals/dealDetailedView",
  async (dealId) => {
    const response = await axios.get(
      `/api/business/dealDetailedView?dealId=${dealId}&user=business`,
    );
    return response.response;
  },
);

export const count = createAsyncThunk(
  "deals/count",
  async ({ type, dealCategoryId }) => {
    const response = await axios.get(
      `/api/business/count/${dealCategoryId}/${type}`,
    );
    return response.response || [];
  },
);

export const dealsSlice = createSlice({
  name: "deals",
  initialState: {
    loading: false,
    error: "",
    dealsStatus: [],
    dealsData: [],
    dealsDataLoading: false,
    raiseReqLoading: false,
    raiseReqError: "",
    approvedeal: [],
    dealunderBus: [],
    statusData: {},
    detailedview: [],
    approvedealform: {},
    disburseDealform: [],
    republishDealform: {},
    rejectDealform: {},
    countData: [],
    cancleDealform: {},
    sendagreeform: {},
    fundDeals: [],
  },

  extraReducers: (builder) => {
    builder.addCase(dealStatusDropdown.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(dealStatusDropdown.fulfilled, (state, action) => {
      state.loading = false;
      state.dealsStatus = action.payload;
    });
    builder.addCase(dealStatusDropdown.rejected, (state, action) => {
      state.loading = false;
      state.dealsStatus = [];
      state.error = action.payload;
    });

    builder.addCase(dealsView.pending, (state) => {
      state.dealsDataLoading = true;
      state.error = "";
    });
    builder.addCase(dealsView.fulfilled, (state, action) => {
      state.dealsDataLoading = false;
      state.dealsData = action.payload;
      state.error = "";
    });
    builder.addCase(dealsView.rejected, (state, action) => {
      state.dealsDataLoading = false;
      state.dealsData = [];
      state.error = action.payload;
    });

    builder.addCase(raiseRequest.pending, (state) => {
      state.raiseReqLoading = true;
      state.raiseReqError = "";
    });
    builder.addCase(raiseRequest.fulfilled, (state, action) => {
      state.raiseReqLoading = false;
      state.raiseReqError = "";
    });
    builder.addCase(raiseRequest.rejected, (state, action) => {
      state.raiseReqLoading = false;
      state.raiseReqError = action.payload;
    });

    builder.addCase(dealDetailedView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(dealDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.detailedview = action.payload;
      state.error = "";
    });
    builder.addCase(dealDetailedView.rejected, (state, action) => {
      state.loading = false;
      state.detailedview = [];
      state.error = action.payload;
    });

    builder.addCase(count.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(count.fulfilled, (state, action) => {
      state.loading = false;
      state.countData = action.payload;
    });
    builder.addCase(count.rejected, (state, action) => {
      state.loading = false;
      state.countData = [];
      state.error = action.error.message;
    });
  },

  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const {} = dealsSlice.actions;

export default dealsSlice.reducer;
